import { createFilm } from "./filmes.utils";

import nxkabasuluPoster from "../images/filmes/nxkabasulu.webp";
import couracaPoster from "../images/filmes/couraca.webp";
import latitudefenixPoster from "../images/filmes/latitudefenix.webp";
import asmaosdapulpeiraPoster from "../images/filmes/asmaosdapulpeira.webp";
import porquehojeesabadoPoster from "../images/filmes/porquehojeesabado.webp";
import ellagosilentePoster from "../images/filmes/ellagosilente.webp";
import horademudarPoster from "../images/filmes/horademudar.webp";
import revoltaPoster from "../images/filmes/revolta.webp";
import procurotPoster from "../images/filmes/procurot.webp";
import ocorpodecristoPoster from "../images/filmes/ocorpodecristo.webp";
import anastaciaPoster from "../images/filmes/anastacia.webp";
import oveuPoster from "../images/filmes/oveu.webp";
import submergidoPoster from "../images/filmes/submergido.webp";
import hanamiPoster from "../images/filmes/hanami.webp";
import amuletoPoster from "../images/filmes/amuleto.webp";
import amemoriaPoster from "../images/filmes/amemoria.webp";

// Bloque curtas "Ventura"
export const nxkaBaSulu = createFilm(
  "N'xka ba sulu / Vou para Angola",
  "Jéssica Lima",
  2026,
  14,
  "",
  "São Tomé e Príncipe / Angola",
  [
    "KUGOMA – Fórum de Cinema Moçambique",
    "Festin – Portugal 2026",
  ],
  "",
  "Entre São Tomé e Príncipe e Angola existe unha conexión atemporal. Guiada polos relatos familiares, a realizadora procura comprender os camiños que a precederon, reconstruíndo a historia dunha avoa que partiu con catro fillos cara ao descoñecido e as pegadas invisibles deixadas por aquela viaxe. Entre imaxes de arquivo e o presente, o filme constrúese como un ensaio narrativo íntimo, onde o persoal e o colectivo se entrelazan. Unha reflexión sobre a pertenza, a memoria e as historias interrompidas que continúan a ecoar nos corpos e nas xeracións seguintes.",
  nxkabasuluPoster
);

export const couraca = createFilm(
  "Couraça",
  "Susan Kalik / Daniel Arcades",
  2025,
  20,
  "",
  "Brasil",
  [
    "Festival de Cine Latinoamericano de Rosario",
    "Generamma – Festival de Cine Realizado por Mujeres",
    "FESTMINA",
    "Mellor Curtametraxe do Público, Mellor Actriz (Laís Machado) e Premio Canal Brasil á Mellor Curtametraxe no 58.º Festival de Brasília",
    "Mellor Película do Público, Mellor Fotografía e Mellor Banda Sonora no 8.º Cine Tamoio",
  ],
  "",
  "Tras a masacre da banda de Lampião, dous amantes cangaceiros percorren o sertão para levar unha cangaceira embarazada de volta á casa da súa familia. Ao longo da viaxe, deberán enfrontarse aos seus propios desexos e ás decisións dun pasado que xa non ten cabida no mundo que os rodea.",
  couracaPoster
);

export const latitudeFenix = createFilm(
  "Latitude Fénix",
  "Welket Bungué",
  2024,
  15,
  "",
  "Portugal / Guiné-Bissau / São Tomé e Príncipe",
  [
    "Caminhos do Cinema Português",
    "Nominación aos Premios Sophia 2025 na categoría de Mellor Curtametraxe de Ficción",
  ],
  "https://www.youtube.com/watch?v=od2BlT_nfTI",
  "Welket Bungué imaxina un encontro imposible entre o Barão de Água Izé e Maria Correia, figuras históricas de São Tomé e Príncipe reencarnadas en corpos contemporáneos. A través da danza, a poesía e a música, o filme cuestiona as relacións de poder, a culpa, a terra e o corpo negro, establecendo un diálogo entre pasado e presente.",
  latitudefenixPoster
);

export const asMaosDaPulpeira = createFilm(
  "As mãos da pulpeira",
  "Silvia Cachafeiro",
  2025,
  14,
  "",
  "Galicia",
  [
    "Mostra de Cinema do Rosal",
    "Cinemafost",
    "Luces, Cameros, Acción",
    "Arcu Atlánticu Xixón",
    "Festival Internacional de Cine de Ourense",
    "Semana de Cine de Lugo",
    "FESCIGU",
    "Festival de Cine de Sorihuela del Guadalimar",
    "London Spanish Film Festival",
  ],
  "",
  "Galicia, anos 50. Unha época e un lugar de pobreza onde mandan os homes. Concha comeza a xornada coa súa amiga Ramona mentres aínda é noite. Os seus maridos dormen. Diríxense ao río para lavar o polbo. Son pulpeiras.",
  asmaosdapulpeiraPoster
);

// Bloque curtas "Saudade"
export const porqueHojeESabado = createFilm(
  "Porque hoje é sábado",
  "Alice Eça Guimarães",
  2025,
  12,
  "",
  "Portugal",
  [
    "Curtas Vila do Conde",
    "Clermont-Ferrand",
    "Anima Brussels",
    "PÖFF Shorts",
    "Cinanima",
    "Gran Premio á Mellor Curtametraxe de Animación e Premio do Gobernador de Tokio no Tokyo Anime Award Festival 2026",
  ],
  "https://vimeo.com/1097800631",
  "É sábado e unha muller loita por conciliar a súa vida familiar coa necesidade de escapar da rutina e dar renda solta á súa faceta creativa. Entre as responsabilidades cotiás e os seus propios desexos, busca un espazo para si mesma nunha vida na que o tempo parece non lle pertencer.",
  porquehojeesabadoPoster
);

export const elLagoSilente = createFilm(
  "El lago silente",
  "Varo López",
  2026,
  14,
  "",
  "Galicia",
  [
    "Festival de Cans",
    "Festival Internacional de Cine Pequeño",
    "Festival de Cine de Zaragoza",
    "Biznaga de Prata – Premio do Público na sección de curtametraxes do Festival de Málaga",
  ],
  "https://vimeo.com/1158149716",
  "Un grupo de viaxeiros intenta cruzar un lago para sobrevivir, pero para conseguilo deberá enfrontarse a un ermitán que vive illado nunha cabana. El é a única persoa capaz de axudalos, aínda que o encontro co misterioso habitante do lugar converterá a súa viaxe nunha experiencia inesperada.",
  ellagosilentePoster
);

export const horaDeMudar = createFilm(
  "Hora de mudar",
  "Pocas Pascoal",
  2024,
  5,
  "",
  "Portugal / Angola",
  [
    "Curtas Vila do Conde",
    "RIDM Montréal",
    "Clermont-Ferrand",
    "Locarno – Open Doors Screenings 2026",
  ],
  "",
  "Nun ensaio experimental de cinco minutos, imaxes de explotación da terra, dos animais e dos corpos conectan colonialismo, capitalismo e destrución ecolóxica. O pasado aparece menos como algo distante que como un mecanismo que continúa en funcionamento. A través do branco e negro, o filme constrúe unha reflexión sobre a violencia exercida sobre os corpos e o territorio.",
  horademudarPoster
);

export const reVolta = createFilm(
  "Re-volta",
  "Pedro Murad, Daniel Herz",
  2026,
  13,
  "",
  "Brasil",
  [
    "FICCS Festival Internacional De Cortometrajes De La Cuenca Del Salado",
    "Islantilla Cinefórum",
    "41º Short Film Market Clermont-Ferrand",
  ],
  "https://www.youtube.com/watch?v=qH8MtklRTG4",
  "Bianca regresa á casa tras visitar a súa nai con motivo da presentación do seu libro, pero o reencontro toma un rumbo inesperado. Segredos gardados durante moito tempo saen á luz e vellos silencios quedan finalmente rotos. A verdade, silenciada durante anos, acaba por resoar entre ambas, abrindo unha ferida que xa non pode permanecer oculta.",
  revoltaPoster
);

export const procuroT = createFilm(
  "Procuro T",
  "Danilo Bastos Godoy",
  2025,
  18,
  "",
  "Portugal / Brasil / Alemaña",
  [
    "Marché du Film Cannes – WIP",
    "Cinemateca Portuguesa",
    "Festival Imigratória",
  ],
  "",
  "Teresa, unha inmigrante brasileira, procura un fogar posible nunha Lisboa atravesada pola especulación inmobiliaria, a xenofobia e a precariedade. A medida que a cidade se pecha sobre ela, a solidariedade e o afecto convértense nas formas máis concretas de refuxio. Nun contexto de incerteza, Teresa busca un lugar ao que poder chamar casa.",
  procurotPoster
);

// Bloque curtas "Lembranças"
export const oCorpoDeCristo = createFilm(
  "O corpo de Cristo",
  "Bea Lema",
  2024,
  12,
  "",
  "Galicia",
  [
    "Aguilar Film Festival",
    "Premio Mestre Mateo 2026 – Mellor Curtametraxe de Animación",
    "Premio do Xurado á Mellor Curtametraxe de Animación – Festival de Cans 2026",
    "Premio á Mellor Curtametraxe Galega – FICBUEU 2026",
  ],
  "",
  "Un demo axexa a casa de Adela, atormentándoa e facéndolle dano. Isto lévaa a consultar un psiquiatra, que lle presenta a medicación como a solución definitiva para todos os seus problemas. Porén, ela precisa de alguén que escoite o que lle está a suceder realmente. O único ámbito onde a súa realidade atopa cabida é na relixión e nos rituais populares, o que a leva a visitar unha curandeira a quen lle confesa como e cando comezou todo.",
  ocorpodecristoPoster
);

export const anastacia = createFilm(
  "Anastácia",
  "Lilih Curi",
  2025,
  15,
  "",
  "Brasil",
  [
    "Festival Internacional de Cine de Lebu",
    "Visões Periféricas",
    "L'Horror Film Festival",
    "Festival de Cinema de Marília",
    "Panorama Internacional Coisa de Cinema",
    "Los Angeles Brazilian Film Festival",
    "For Rainbow",
    "Cinefest Votorantim",
  ],
  "",
  "Anastasia queda impedida para traballar despois de perder a voz. Ao mesmo tempo, atópase atrapada nunha relación opresiva e abusiva. A perda da súa capacidade para comunicarse agrava o seu illamento e convértea nunha prisioneira dunha realidade da que cada vez lle resulta máis difícil escapar.",
  anastaciaPoster
);

export const oVeu = createFilm(
  "O véu",
  "Gabriel Motta",
  2025,
  20,
  "",
  "Brasil",
  [
    "Toronto International Film Festival – TIFF",
    "Festival Internacional de Cine de Guadalajara",
    "San Francisco International Film Festival",
    "Palm Springs International ShortFest",
    "Bucheon International Fantastic Film Festival – BIFAN",
    "Galway Film Fleadh",
    "Curta Cinema",
    "Kinoforum",
    "Mellor Dirección no Festival de Cinema de Gramado",
    "Mellor Deseño de Son no CINE-PE",
  ],
  "https://vimeo.com/1097559850",
  "Un culto relixioso baseado en falsos rituais de posesión adquire proporcións macabras cando a filla do pastor é realmente posuída por unha entidade. O que comeza como unha representación destinada a espertar a fe e a crenza convértese nunha experiencia aterradora que ninguén parece capaz de controlar.",
  oveuPoster
);

export const submergido = createFilm(
  "Submergido",
  "Ariel Añez",
  2025,
  14,
  "",
  "Mozambique",
  [
    "International Film Festival Rotterdam – IFFR",
  ],
  "",
  "A historia acompaña unha familia profundamente marcada polo conflito armado en Cabo Delgado, Mozambique. Cando o soldado Amarildo desaparece en combate, os rumores sobre unha suposta deserción comezan a destruír emocionalmente a súa familia. O seu irmán Sérgio regresa á casa para comunicar a tráxica noticia, pero descobre algo misterioso: o seu sobriño Pércio mantén unha conexión silenciosa, profunda e inexplicable co pai ausente. O filme afástase da violencia física da guerra para mergullarse no trauma persoal e colectivo, explorando a memoria, os silencios e a dor da ausencia.",
  submergidoPoster
);

// Longametraxes
export const hanami = createFilm(
  "Hanami",
  "Denise Fernandes",
  2024,
  96,
  "",
  "Cabo Verde / Portugal / Suíza",
  [
    "Chicago International Film Festival",
    "BFI London Film Festival",
    "Palm Springs International Film Festival",
    "Seattle International Film Festival",
    "Thessaloniki International Film Festival",
    "FESPACO",
    "Journées Cinématographiques de Carthage",
    "Mellor Directora Emerxente e mención especial en Primeira Obra – Locarno 2024",
    "Mellor Película – Mostra Internacional de Cinema de São Paulo",
    "Premio MAX á mellor película portuguesa – IndieLisboa",
    "Montgolfière de Ouro – Festival dos Tres Continentes de Nantes",
    "Ingmar Bergman Award – Göteborg Film Festival",
  ],
  "",
  "Nunha remota illa volcánica, un lugar do que todos queren marchar, Nana aprendeu a quedarse. A súa nai, Nia, que padece unha misteriosa enfermidade, abandonouna pouco despois do seu nacemento. Cando Nana sofre unha febre alta, envíana aos pés dun volcán para recibir tratamento. Alí descobre un mundo suspendido entre os soños e a realidade. Anos despois, xa adolescente, Nana ve regresar a súa nai.",
  hanamiPoster
);

export const amuleto = createFilm(
  "Amuleto",
  "Igor Barradas / Heraldo HB",
  2025,
  92,
  "",
  "Brasil",
  [
    "28º Festival Internacional de Cinema do Rio de Janeiro – Première Brasil Documental",
    "5º Festival Mate com Angu de Cinema",
    "29ª Mostra de Cinema de Tiradentes",
    "19ª Mostra Visões Periféricas – Rio de Janeiro",
    "2º Festival Internacional Goitacá de Cinema – Filme de apertura",
    "Sesión Cine Satyros Bijou – São Paulo",
    "9ª Mostra Sesc de Cinema – Panorama Brasileiro",
    "9º Festival de Cinema de Jaraguá do Sul",
    "4º Festival Internacional de Cinema de Goiânia",
    "Mellor filme fluminense – XI Mostra SESC de Cinema",
    "Premio BiC 2025 – Festival BXD em Cena",
    "Premio CCM á Mellor Longametraxe – 7º Festival de Cinema de Marília",
  ],
  "https://www.youtube.com/watch?v=5YLxIevsBC4",
  "A historia de O Amuleto de Ogum, filme de 1975 de Nelson Pereira dos Santos, é contada desde a perspectiva de Duque de Caxias e revela como os artistas das periferias urbanas tamén concibían o cinema brasileiro. O filme convértese nun acto político que demostra que a periferia non só era representada, senón que tamén participaba activamente na produción cinematográfica, contra todo prognóstico.",
  amuletoPoster
);

export const aMemoriaDoCheiroDasCoisas = createFilm(
  "A memória do cheiro das coisas",
  "António Ferreira",
  2025,
  96,
  "",
  "Portugal / Brasil",
  [
    "Mellor Actor – Shanghai",
    "Mellor Guión – Tánger",
    "Seleccionado por Portugal para representar ao país nos Óscares 2027",
  ],
  "",
  "Un drama intimista sobre un veterano da Guerra Colonial obrigado a ingresar nunha residencia de maiores, onde se enfronta ás pantasmas do seu pasado. Alí establece un vínculo inesperado co seu coidador negro, unha relación que lle permitirá confrontar os recordos da guerra e revisar unha parte da súa vida que permanecera silenciada durante anos.",
  amemoriaPoster
);

export const filmes2026 = [
  // Bloque curtas "Ventura"
  nxkaBaSulu,
  couraca,
  latitudeFenix,
  asMaosDaPulpeira,

  // Bloque curtas "Saudade"
  porqueHojeESabado,
  elLagoSilente,
  horaDeMudar,
  reVolta,
  procuroT,

  // Bloque curtas "Lembranças"
  oCorpoDeCristo,
  anastacia,
  oVeu,
  submergido,

  // Longametraxes
  hanami,
  amuleto,
  aMemoriaDoCheiroDasCoisas,
];
